export const SEARCH_KEYS = {
  boost: ['uuid', 'store', 'game', 'g2gSellID', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'takers', 'notes',
    'hotOrders.currency',
    'hotOrders.description',
    'hotOrders.game',
    'hotOrders.notes',
    'hotOrders.takerName',
    'hotOrders.takerID',
    'hotOrders.title'
  ],
  account: ['uuid', 'store', 'game', 'g2gSellID', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'takers', 'notes',
    'hotOrders.currency',
    'hotOrders.description',
    'hotOrders.game',
    'hotOrders.notes',
    'hotOrders.takerName',
    'hotOrders.takerID',
    'hotOrders.title'
  ],
  currencyBuy: ['uuid', 'game', 'server', 'account', 'supplier', 'notes', 'takerName'],
  currencySell: ['uuid', 'store', 'game', 'g2gSellID', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'takers', 'notes'],
  giftCard: ['uuid', 'store', 'g2gSellID', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'takers', 'notes',
    'hotOrders.currency',
    'hotOrders.description',
    'hotOrders.game',
    'hotOrders.notes',
    'hotOrders.takerName',
    'hotOrders.takerID',
    'hotOrders.title'
  ],
  item: ['uuid', 'store', 'game', 'g2gSellID', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'takers', 'notes',
    'hotOrders.currency',
    'hotOrders.description',
    'hotOrders.game',
    'hotOrders.notes',
    'hotOrders.takerName',
    'hotOrders.takerID',
    'hotOrders.title'
  ],
  shop: ['id', 'title', 'customer', 'customerName', 'customerDiscordUsername', 'notes'],
  stock: ['id', 'game', 'server', 'account', 'notes'],
  gold: ['game', 'server'],
  boostSubOrders: ['currency', 'description', 'game', 'id', 'notes', 'orderID', 'state', 'takerName', 'title', 'uuid'],
};